import { mapGetters, mapActions } from 'vuex'
import { socialMedia } from '@/constants'


const mixin = {
  computed: {
    ...mapGetters('socialMediaChannel', ['socialMediaChannels'])
  },


  methods: {
    ...mapActions('socialMediaChannel', ['createSocialMediaChannel', 'updateSocialMediaChannel', 'deleteSocialMediaChannel']),

    async addSocialMediaChannel (socialMediaId) {
      let channels = []

      try {
        switch (socialMediaId) {
          case socialMedia.facebook:
            channels = await this.addFacebookPage(socialMedia)
            break
          case socialMedia.wordPress:
            channels = await this.addWordPressEndpoint(socialMedia)
            break
          default:
            this.showSnackbarError('Not implemented')
        }

        const addedChannels = []

        for (const channel of channels) {
          channel.socialMediaId = socialMediaId
          const existingChannel = this.socialMediaChannels.find(x => x.externalId === channel.externalId)

          if (existingChannel) {
            channel.id = existingChannel.id
            await this.updateSocialMediaChannel(channel)
          } else {
            const addedChannel = await this.createSocialMediaChannel(channel)
            addedChannels.push(addedChannel)
          }
        }

        return addedChannels
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    async removeSocialMediaChannel (channel) {
      try {
        const confirm = await this.$confirm(this.$t('marketing.removeSocialMediaChannel', channel), { trueText: this.$t('remove') })
        if (!confirm) return

        await this.deleteSocialMediaChannel(channel.id)
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },


    async addFacebookPage () {
      const loginResponse = await new Promise(resolve => {
        FB.login(resolve, { scope: 'manage_pages,publish_pages,pages_manage_posts,pages_read_engagement' })
      })

      if (loginResponse.authResponse) {
        const accountsResponse = await new Promise(resolve => {
          FB.api('/me/accounts', resolve)
        })

        const channels = []
        for (const account of accountsResponse.data) {
          channels.push({
            name: account.name,
            externalId: account.id,
            accessToken: account.access_token
          })
        }

        return channels
      }

      return []
    },


    async addWordPressEndpoint () {
      const result = await this.$wordpress.connect()

      if (result) {
        const url = new URL(result.url)
        return [{
          name: url.host,
          externalId: url.origin
        }]
      } else {
        return []
      }
    }
  }
}

export default mixin
